
import { useContext, useEffect, useState } from "react";
import Logo from "../../assets/images/logo.png";
import googleIcon from "../../assets/images/googleIcon.png";
import heroImage from "../../assets/images/loginHeroImage.jpg";
import { MyContext } from "../../App";
import { MdEmail } from "react-icons/md";
import { RiLockPasswordFill } from "react-icons/ri";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { editData, postData } from "../../utils/api";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { firebaseApp } from "../../firebase";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

const auth = getAuth(firebaseApp);
const googleProvider = new GoogleAuthProvider();

const Login = () => {
  const [inputIndex, setInputIndex] = useState(null);
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenVerifyEmailBox, setIsOpenVerifyEmailBox] = useState(false);
  const [formfields, setFormfields] = useState({
    email: "",
    password: "",
    isAdmin: true,
  });
  const context = useContext(MyContext);
  const navigate = useNavigate();

  useEffect(() => {
    context.setisHideSidebarAndHeader(true);
    const token = localStorage.getItem("token");
    if (token) navigate("/");
  }, []);

  const focusInput = (i) => setInputIndex(i);
  const onchangeInput = (e) =>
    setFormfields((p) => ({ ...p, [e.target.name]: e.target.value }));

  const signIn = (e) => {
    e.preventDefault();
    if (!formfields.email) {
      return context.setAlertBox({ open: true, error: true, msg: "Email cannot be blank!" });
    }

    if (!isOpenVerifyEmailBox && !formfields.password) {
      return context.setAlertBox({ open: true, error: true, msg: "Password cannot be blank!" });
    }

    setIsLoading(true);

    if (!isOpenVerifyEmailBox) {
      postData("/api/user/signin", formfields)
        .then((res) => {
          setIsLoading(false);
          if (!res.error) {
            if (!res.user?.isAdmin)
              return context.setAlertBox({ open: true, error: true, msg: "You are not an admin." });

            localStorage.setItem("token", res.token);
            localStorage.setItem("user", JSON.stringify({
              name: res.user.name,
              email: res.user.email,
              userId: res.user.id,
              isAdmin: res.user.isAdmin,
            }));
            context.setAlertBox({ open: true, error: false, msg: "Admin Login Successfully!" });
            context.setIsLogin(true);
            setTimeout(() => navigate("/dashboard"), 2000);
          } else {
            if (res.isVerify === false) setIsOpenVerifyEmailBox(true);
            context.setAlertBox({ open: true, error: true, msg: res.msg });
          }
        })
        .catch((err) => {
          setIsLoading(false);
          console.error(err);
          context.setAlertBox({ open: true, error: true, msg: "Something went wrong!" });
        });
    } else {
      // Resend verification OTP
      postData("/api/user/verifyAccount/resendOtp", { email: formfields.email })
        .then((res) => {
          if (res?.otp && res.existingUserId) {
            editData(`/api/user/verifyAccount/emailVerify/${res.existingUserId}`, {
              email: formfields.email,
              otp: res.otp,
            })
              .finally(() => {
                setIsLoading(false);
                navigate("/verify-account");
              });
          } else {
            setIsLoading(false);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          console.error(err);
        });
    }
  };

  const signInWithGoogle = () => {
    signInWithPopup(auth, googleProvider)
      .then((result) => {
        const u = result.user.providerData[0];
        const fields = {
          name: u.displayName,
          email: u.email,
          password: null,
          images: u.photoURL,
          phone: u.phoneNumber,
          isAdmin: true,
        };
        postData("/api/user/authWithGoogle", fields)
          .then((res) => {
            setIsLoading(false);
            if (!res.error) {
              localStorage.setItem("token", res.token);
              localStorage.setItem("user", JSON.stringify({
                name: res.user.name,
                email: res.user.email,
                userId: res.user.id,
              }));
              context.setAlertBox({ open: true, error: false, msg: res.msg });
              context.setIsLogin(true);
              setTimeout(() => navigate("/dashboard"), 2000);
            } else {
              context.setAlertBox({ open: true, error: true, msg: res.msg });
            }
          })
          .catch((err) => {
            setIsLoading(false);
            console.error(err);
          });
      })
      .catch((error) => {
        setIsLoading(false);
        context.setAlertBox({ open: true, error: true, msg: error.message });
      });
  };

  const particlesInit = async (main) => {
    await loadFull(main);
  };

  return (
    <>
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          fullScreen: { enable: true },
          background: { color: "#f0f4f8" },
          fpsLimit: 60,
          particles: {
            number: { value: 60, density: { enable: true, area: 800 } },
            color: { value: "#1976d2" },
            shape: { type: "circle" },
            opacity: { value: 0.2, random: true, anim: { enable: true, speed: 1, opacity_min: 0.1, sync: false } },
            size: { value: 4, random: { enable: true, minimumValue: 2 } },
            links: { enable: true, distance: 150, color: "#1976d2", opacity: 0.1, width: 1 },
            move: { enable: true, speed: 1.2, direction: "none", outModes: "bounce", bounce: true },
          },
          detectRetina: true,
        }}
      />

      <section className="loginSection d-flex align-items-center justify-content-center">
        <div className="loginContainer shadow-lg">
          <div className="loginBox card p-5">
            <Link to="/" className="logo text-center mb-4 d-block">
              <img src={Logo} height="48" alt="logo" />
              <h1 className="mt-3 mb-0">RISMIC MART</h1>
              <small className="text-muted">Admin Panel</small>
            </Link>

            <div className="formWrapper mt-4">
              {isOpenVerifyEmailBox && (
                <h4 className="mb-4 text-center text-primary">Verify Your Email</h4>
              )}
              <form onSubmit={signIn}>
                <div className={`form-group ${inputIndex === 0 ? "focus" : ""}`}>
                  <span className="icon"><MdEmail /></span>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email"
                    name="email"
                    onFocus={() => focusInput(0)}
                    onBlur={() => setInputIndex(null)}
                    onChange={onchangeInput}
                    required
                    autoComplete="username"
                  />
                </div>

                {!isOpenVerifyEmailBox && (
                  <div className={`form-group ${inputIndex === 1 ? "focus" : ""}`}>
                    <span className="icon"><RiLockPasswordFill /></span>
                    <input
                      type={isShowPassword ? "text" : "password"}
                      className="form-control"
                      placeholder="Password"
                      name="password"
                      onFocus={() => focusInput(1)}
                      onBlur={() => setInputIndex(null)}
                      onChange={onchangeInput}
                      required
                      autoComplete="current-password"
                    />
                    <span
                      className="toggleShowPassword"
                      onClick={() => setIsShowPassword(!isShowPassword)}
                    >
                      {isShowPassword ? <IoMdEyeOff /> : <IoMdEye />}
                    </span>
                  </div>
                )}

                <div className="form-group mt-4">
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className="w-100 py-2"
                    disabled={isLoading}
                    sx={{ fontWeight: "600", fontSize: "1rem", borderRadius: 3 }}
                  >
                    {isLoading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : isOpenVerifyEmailBox ? (
                      "Verify Email"
                    ) : (
                      "Sign In"
                    )}
                  </Button>
                </div>
              </form>

              {!isOpenVerifyEmailBox && (
                <>
                  <div className="forgotPassword text-center mt-3">
                    <Link to="/forgot-password" className="text-primary fw-semibold">
                      Forgot Password?
                    </Link>
                  </div>

                  <div className="divider my-4">
                    <span>OR</span>
                  </div>

                  <Button
                    variant="outlined"
                    className="w-100 btn-google"
                    onClick={signInWithGoogle}
                    startIcon={<img src={googleIcon} alt="google" width={20} />}
                    sx={{
                      color: "#1976d2",
                      borderColor: "#1976d2",
                      fontWeight: 600,
                      textTransform: "none",
                      py: 1.5,
                      "&:hover": { backgroundColor: "#1976d2", color: "white" },
                    }}
                  >
                    Sign In with Google
                  </Button>

                  <div className="registerText mt-4 text-center">
                    <span className="text-secondary">Don't have an account? </span>
                    <Link to="/signUp" className="text-primary fw-semibold">
                      Register
                    </Link>
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="heroImageWrapper d-none d-md-block">
            <img src={heroImage} alt="Login hero" />
          </div>
        </div>
      </section>

      {/* Styles */}
      <style jsx="true">{`
        #tsparticles {
          position: fixed;
          z-index: -1;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, #e8f0fe 0%, #f0f4f8 100%);
        }
       /* Main login section - centered */
  .loginSection {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 20px;
    background: transparent;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }

  /* Container for login form and hero */
  .loginContainer {
    display: flex;
    max-width: 900px;
    width: 100%;
    border-radius: 24px;
    overflow: hidden;
    background: #ffffff;
     box-shadow: 0 15px 25px rgba(0, 0, 0, 0.2);
    transition: box-shadow 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  }

  
  /* Left box - form area */
  .loginBox {
    flex: 1 1 400px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 50px 40px;
    border-radius: 24px 0 0 24px;
    user-select: none;
  }

  /* Logo container */
  .logo img {
    display: block;
    margin: 0 auto;
    max-width: 130px;
    filter: drop-shadow(0 0 4px rgba(25, 118, 210, 0.6));
  }

  .logo h1 {
    font-weight: 800;
    font-size: 2.8rem;
    margin: 18px 0 5px;
    color: #1976d2;
    text-align: center;
    letter-spacing: 1.2px;
  }

  .logo small {
    font-size: 1.1rem;
    color: #666666dd;
    font-weight: 500;
    text-align: center;
    display: block;
    margin-bottom: 35px;
  }

  /* Form group */
  .form-group {
    position: relative;
    margin-bottom: 28px;
  }

  /* Icon inside input */
  .form-group .icon {
    position: absolute;
    top: 50%;
    left: 18px;
    transform: translateY(-50%);
    color: #1976d2cc;
    font-size: 22px;
    transition: color 0.3s ease;
  }

  /* Icon color on focus */
  .form-group.focus .icon,
  .form-group input:focus + .icon {
    color: #004ba0;
  }

  /* Inputs */
  .form-group input {
    width: 100%;
    padding: 16px 52px 16px 52px;
    border: 2.5px solid #d3d9e6;
    border-radius: 14px;
    font-size: 17px;
    font-weight: 600;
    color: #222222ee;
    background-color: #fafbfe;
    transition: border-color 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease;
    box-shadow: inset 0 3px 7px rgb(0 0 0 / 0.04);
  }

  /* Placeholder style */
  .form-group input::placeholder {
    color: #a3a9bf;
    font-weight: 500;
    font-style: italic;
  }

  /* Input focus */
  .form-group input:focus {
    border-color: #1976d2;
    background-color: #fff;
    outline: none;
    box-shadow: 0 0 12px rgba(25, 118, 210, 0.45);
  }

  /* Password toggle */
  .toggleShowPassword {
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    color: #1976d2cc;
    font-size: 22px;
    transition: color 0.3s ease;
    user-select: none;
  }

  .toggleShowPassword:hover {
    color: #004ba0;
  }

  /* Google button */
  .btn-google {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    font-weight: 700;
    font-size: 1rem;
    border-radius: 14px !important;
    padding: 14px 28px !important;
    background: linear-gradient(90deg, #4285f4 0%, #2a56c6 100%);
    color: white !important;
    box-shadow: 0 6px 14px rgba(66, 133, 244, 0.5);
    transition: background 0.3s ease, box-shadow 0.3s ease;
  }

  .btn-google:hover {
    background: linear-gradient(90deg, #2a56c6 0%, #1749a1 100%);
    box-shadow: 0 8px 18px rgba(42, 86, 198, 0.7);
  }

  /* Forgot password */
  .forgotPassword a {
    color: #1976d2dd;
    text-decoration: none;
    font-weight: 600;
    font-size: 0.95rem;
    transition: color 0.3s ease;
  }

  .forgotPassword a:hover {
    color: #004ba0;
    text-decoration: underline;
  }

  /* Divider */
  .divider {
    display: flex;
    align-items: center;
    text-align: center;
    margin: 32px 0;
    color: #bbb;
    font-weight: 700;
    font-size: 1rem;
    letter-spacing: 0.06em;
  }

  .divider span {
    flex: 1;
    border-bottom: 1.8px solid #ddd;
    line-height: 0.1em;
    margin: 0 14px;
  }

  /* Register text */
  .registerText {
    font-size: 1rem;
    color: #555555cc;
    margin-top: 22px;
    text-align: center;
  }

  .registerText a {
    color: #1976d2;
    font-weight: 700;
    text-decoration: none;
    transition: color 0.3s ease;
  }

  .registerText a:hover {
    color: #004ba0;
    text-decoration: underline;
  }

  /* Hero image wrapper */
  .heroImageWrapper {
    flex: 1 1 420px;
    overflow: hidden;
    border-radius: 0 24px 24px 0;
    position: relative;
    background: linear-gradient(135deg, #1976d2, #63a4ff);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .heroImageWrapper img {
    max-width: 100%;
    height: 100%;
    object-fit: cover;
    filter: brightness(0.83);
    transition: filter 0.35s ease;
    border-radius: 0 24px 24px 0;
    user-select: none;
    pointer-events: none;
  }

  .heroImageWrapper:hover img {
    filter: brightness(1);
  }

  /* Responsive adjustments */
  @media (max-width: 880px) {
    .loginContainer {
      max-width: 100%;
      margin: 0 15px;
    }
  }

  @media (max-width: 768px) {
    .loginContainer {
      flex-direction: column;
      border-radius: 24px;
      box-shadow: 0 20px 35px rgba(25, 118, 210, 0.18);
    }
    .loginBox {
      border-radius: 24px 24px 0 0;
      padding: 40px 30px;
    }
    .heroImageWrapper {
      display: none;
    }
  }

  @media (max-width: 400px) {
    .loginBox {
      padding: 30px 20px;
    }
    .logo h1 {
      font-size: 2rem;
    }
  }
`}</style>
    </>
  );
};

export default Login;
